import { PAPER_RIGHT_PADDING_PX } from "src/components/paper";

/**
 * The agent sidebar sits beside the page card, on the page background — they
 * are siblings in `NewPage`'s `<Row>{Paper}{sidebar}</Row>`.
 *
 * The two horizontal gaps are derived rather than hand-tuned so they cannot
 * drift apart: the card→rail gap *is* the Paper's own right padding, and the
 * rail→viewport gap is set from the same constant. Sidebar content then adds
 * `AGENT_SIDEBAR_OVERLAY_INSET_PX` on both sides, so expanded content sits
 * equally far from the card and from the viewport.
 */
export const AGENT_SIDEBAR_EDGE_GAP_PX = PAPER_RIGHT_PADDING_PX;
export const AGENT_SIDEBAR_OVERLAY_INSET_PX = AGENT_SIDEBAR_EDGE_GAP_PX * 2;

export const AGENT_SIDEBAR_WIDTH_PX = 400;

/** Docked beside the page from this breakpoint up, overlaid over it below. */
export const AGENT_SIDEBAR_DOCK_BREAKPOINT = "xl";

/** Overlaid, the gap between the panel's inset edge and its content box. */
export const AGENT_SIDEBAR_OVERLAY_CONTENT_GAP_PX = 2;

/**
 * Both the docked rail and the overlaid panel clip their content, so each
 * keeps one spacing unit of right padding inside the clip for anything that
 * paints past its controls' boxes.
 */
export const AGENT_SIDEBAR_CLIP_PADDING_PX = 4;

/**
 * Overlaid, the content box sits a fixed distance from the viewport's right
 * edge per the design; the panel surface extends outward around it by the
 * clip padding.
 */
export const AGENT_SIDEBAR_OVERLAY_RIGHT_PX =
  AGENT_SIDEBAR_OVERLAY_INSET_PX +
  AGENT_SIDEBAR_OVERLAY_CONTENT_GAP_PX -
  AGENT_SIDEBAR_CLIP_PADDING_PX;

/** CollapsedRailButton's boxSize, in Chakra spacing units. */
export const COLLAPSED_RAIL_BUTTON_BOX_SIZE = 8;
export const COLLAPSED_RAIL_BUTTON_SIZE_PX = COLLAPSED_RAIL_BUTTON_BOX_SIZE * 4;

/** The docked, expanded rail's footprint in the page row, including its right margin. */
export const AGENT_SIDEBAR_DOCKED_WIDTH_PX =
  AGENT_SIDEBAR_WIDTH_PX + AGENT_SIDEBAR_EDGE_GAP_PX;
